export default function sizeLumaEmbeds() {
  document.querySelectorAll('iframe[data-luma-embed]').forEach((iframe) => {
    const updateHeight = () => {
      const width = Math.floor(iframe.getBoundingClientRect().width);
      if (width <= 0) return;

      // Measured estimates for Luma's responsive layouts; checkout keeps its own scrolling.
      const height = String(width <= 450 ? 960 : width <= 650 ? 880 : 580);
      if (iframe.height !== height) iframe.height = height;
    };

    updateHeight();
    iframe.addEventListener('load', updateHeight);

    // Observe the embed width because the sidebar changes it independently of the viewport.
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateHeight).observe(iframe);
    } else {
      window.addEventListener('resize', updateHeight);
    }
  });
}
